///<refernce path='../../WebUI/typings/tsd.d.ts'/>
import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "./Strings";

export interface SearchControlProps extends React.Props<SearchControl> {
    onSearch: (search: string) => void;
    toggleSearchOpen: () => void;
    value: string;
    expandSearch?: boolean;
    promptText?: string;
}
export interface SearchControlState {
    searchString?: string;
}

export class SearchControl extends React.Component<SearchControlProps, SearchControlState> {
    private searching = false;

    constructor(props : SearchControlProps) {
        super(props);
        this.state = { searchString: ''};
    }

    public render(): JSX.Element {
        var searchBoxClass = this.props.expandSearch ? "searchBox expand" : "searchBox";
        return (
            <div className="search-outter">
                <div className="open-search" ref="open-search" onClick={_.debounce(_.bind(this.toggleSearchForm, this), 100, true)}/>
                <div ref="searchDiv" className={searchBoxClass}>
                    {/*need a form to force mobile soft keyboard to show either 'Search' or 'Go' as virutal button*/}
                    <form method="GET" action="" onSubmit={_.bind(this.onSearchClicked, this)}>
                        <input ref="searchInput"
                            name="searchInput"
                            type="text"
                            key="search_text"
                            className="searchText"
                            placeholder={ this.props.promptText || "Search Microsoft " + resourceStrings.botDirectory + "\u2026" }
                            value={this.state.searchString || ''}
                            onChange= { _.bind(this.onChange, this) }
                            onKeyDown= {_.bind(this.onKey, this)}
                            />
                        <button type="submit" ref="searchIcon" className="icon-search" name="submit_search">
                            <span>Search</span>
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    private toggleSearchForm(e: React.MouseEvent<any>) {
        this.props.toggleSearchOpen();
    }

    private onSearchClicked(e: React.UIEvent<any> | React.FormEvent<any>) : boolean {
        var $searchInput = $(ReactDOM.findDOMNode(this.refs["searchInput"]));
        var $div = $(ReactDOM.findDOMNode(this.refs["searchDiv"]));
        e.stopPropagation();
        e.preventDefault();
        var searchText = $searchInput.val().trim();
        if (searchText) {
            this.props.onSearch(searchText);
        } else {
            var willExpand = !$div.hasClass('expand')
            $div.toggleClass('expand');
            if (willExpand) {
                $searchInput.focus();
            }
        }
        return false;
    }

    private onChange(e: React.FormEvent<any>) {
        var target = e.target as any;
        var text = target['value'];
        this.setState({searchString: text});
    }

    private onKey(e: React.KeyboardEvent<any>) {
        if (e.key === 'Enter') {
            this.props.onSearch(this.state.searchString.trim());
            e.preventDefault();
        }
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/SearchControl.tsx